module.exports = __webpack_public_path__ + "static/img/zhongzhongka7.2e7c3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka7.png
// module id = cVVw
// module chunks = 16